/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Faq_Q6_AnswerInputs */

const en_home_faq_q6_answer = /** @type {(inputs: Home_Faq_Q6_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Depending on your coverage, you may have access to healthcare navigation through Novus Health, legal resources through Legaroo, and other value-added services.`)
};

const fr_home_faq_q6_answer = /** @type {(inputs: Home_Faq_Q6_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selon votre couverture, vous pourriez avoir accès à la navigation en santé via Novus Health, à des ressources juridiques via Legaroo, et à d'autres services à valeur ajoutée.`)
};

/**
* | output |
* | --- |
* | "Depending on your coverage, you may have access to healthcare navigation through Novus Health, legal resources through Legaroo, and other value-added services." |
*
* @param {Home_Faq_Q6_AnswerInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const home_faq_q6_answer = /** @type {((inputs?: Home_Faq_Q6_AnswerInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Faq_Q6_AnswerInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_faq_q6_answer(inputs)
	return fr_home_faq_q6_answer(inputs)
});